const THEMES = [
  {
    id: 'velocity-rebel',
    keywords: ['velocity rebel', 'velocityrebel'],
    from: '14 92% 54%',
    via: '338 86% 54%',
    to: '268 84% 56%'
  },
  {
    id: 'health',
    keywords: ['health', 'medical', 'medicine', 'patient', 'clinical', 'medexplain'],
    from: '142 72% 40%',
    via: '158 78% 42%',
    to: '178 76% 38%'
  },
  {
    id: 'games',
    keywords: ['games', 'browser-game', 'endless runner', 'barkdash', 'pixel-art'],
    from: '84 82% 42%',
    via: '142 76% 40%',
    to: '174 78% 36%'
  },
  {
    id: 'tiktok-tools',
    keywords: ['social media tools', 'tiktok downloader', 'tikdownload', 'tokdownloader'],
    from: '182 88% 44%',
    via: '326 86% 53%',
    to: '350 88% 54%'
  },
  {
    id: 'mockup-tools',
    keywords: ['ai image & design tools', 'creative studio', 'mocksy', 'mockup'],
    from: '276 84% 57%',
    via: '316 82% 57%',
    to: '348 87% 59%'
  },
  {
    id: 'qr-tools',
    keywords: ['qr code', 'qr code generator', 'qrai', 'branded qr'],
    from: '36 92% 52%',
    via: '164 77% 43%',
    to: '190 82% 45%'
  },
  {
    id: 'audio',
    keywords: ['audio', 'music', 'sound', 'podcast', 'song', 'beat'],
    from: '262 90% 55%',
    via: '292 85% 55%',
    to: '330 85% 55%'
  },
  {
    id: 'video',
    keywords: ['video', 'film', 'movie', 'youtube', 'vlog', 'reels'],
    from: '0 80% 55%',
    via: '20 90% 55%',
    to: '40 95% 55%'
  },
  {
    id: 'ai',
    keywords: ['ai', 'gpt', 'llm', 'agent', 'chatbot', 'automation'],
    from: '200 90% 55%',
    via: '220 90% 55%',
    to: '260 90% 55%'
  },
  {
    id: 'design',
    keywords: ['image', 'photo', 'design', 'logo', 'art', 'figma'],
    from: '168 84% 55%',
    via: '190 85% 55%',
    to: '210 90% 55%'
  },
  {
    id: 'marketing',
    keywords: ['marketing', 'seo', 'campaign', 'growth', 'sales'],
    from: '30 95% 55%',
    via: '50 95% 55%',
    to: '80 80% 55%'
  },
  {
    id: 'developer',
    keywords: ['dev', 'code', 'api', 'git', 'deploy', 'database'],
    from: '240 80% 55%',
    via: '200 80% 50%',
    to: '180 80% 50%'
  },
  {
    id: 'social',
    keywords: ['social', 'instagram', 'tiktok', 'linkedin', 'discord'],
    from: '320 85% 55%',
    via: '300 85% 55%',
    to: '270 85% 55%'
  }
];

const FALLBACKS = [
  ['210 80% 55%', '260 80% 55%', '320 80% 55%'],
  ['150 70% 50%', '200 80% 55%', '260 80% 55%'],
  ['10 80% 55%', '40 80% 55%', '80 70% 50%'],
  ['260 80% 55%', '220 85% 55%', '180 80% 50%']
];

function hash(value) {
  let result = 0;
  for (const character of value) {
    result = (result * 31 + character.charCodeAt(0)) | 0;
  }
  return Math.abs(result);
}

export function getCategoryGradient(title = '', category = '') {
  const text = `${title} ${category}`.toLowerCase();
  const matched = THEMES.find((theme) =>
    theme.keywords.some((keyword) => text.includes(keyword))
  );
  if (matched) return matched;
  const [from, via, to] = FALLBACKS[hash(title || category || 'x') % FALLBACKS.length];
  return { from, via, to };
}

export const gradientCss = ({ from, via, to }) =>
  `linear-gradient(135deg,hsl(${from}) 0%,hsl(${via}) 50%,hsl(${to}) 100%)`;